
var profiles = [
    {
        profile : 1,
        url: "https://www.vinidaily.com/profil-feuille-de-vigne",
        logo: "vigne",
        name: "<b>La Feuille de Vigne</b>",
        adj: "Souple",
        description1: "Les vins qui vous conviennent le mieux sont <b>légers</b> et <b>souples</b>.",
        description2: "Si votre médecin vous a toujours demandé de vous assouplir, c'est probablement parce vous buviez le mauvais vin.",
        description3: "<b>Facile à boire</b>, contenant <b>peu de tannins</b> et d'<b>acidité</b>."
    },
    {
        profile : 2,
        url: "https://www.vinidaily.com/profil-grappe",
        logo: "grappe",
        name: "<b>La Grappe</b>",
        adj: "Généreux",
        description1: "Les vins qui vous conviennent le mieux sont <b>généreux</b> et <b>intenses</b>.",
        description2: "On vous comparera à l'<b>Abbé Pierre</b> du vin, <b>mère Teresa</b> ou <b>Brigitte Bardot</b>",
        description3: "Plus le vin est <b>généreux</b>, plus il est riche en alcool."
    },
    {
        profile : 3,
        url: "https://www.vinidaily.com/profil-barrique",
        logo: "barrique",
        name: "<b>La Barrique</b>",
        adj: "Structuré",
        description1: "Les vins qui vous conviennent le mieux sont <b>puissants</b> et <b>structurés</b>",
        description2: "",
        description3: "La <b>structure</b> du vin peut-être comparée à la <b>physionomie humaine</b>. Elle peut-être <b>plate, massive...</b> Là, on est un peu sur le <b>Teddy Riner</b> des bouteilles de vin."
    }

]


export default profiles